// forensicsController
(function () {

    'use strict';
    angular.module('app')
        .controller('impersonateController',
            [
                '$routeParams', '$location', 'impersonateService', '_',
                impersonateController
            ]
        );

    function impersonateController($routeParams, $location, impersonateService, _) {
        var vm = this;
        var base;
        vm.accountId = $routeParams.accountId;

        var bases = document.getElementsByTagName('base');
        var baseHref = null;

        if (bases.length > 0) {
            base = bases[0].href;
        }
        else {
            base = location.origin;
        }

        if (!_.isUndefined(vm.accountId) && vm.accountId === 'reset') {
            
            location.href = base + '/api/impersonate/reset';
            //$location.url('/api/impersonate/reset');
        }  else if (!_.isUndefined(vm.accountId)) {
           location.href = base + '/api/impersonate/account?accountId=' + vm.accountId;
            //$location.url('/api/impersonate/account?accountId=' + vm.accountId);
        }
    }
})();